import { Group } from '@/router/group.model';
import { manageLoyalty, refundReturnPolicy } from '@/router/routes';
import { loyaltyWidget, programStatus } from '../routes';

const routes = [
  programStatus,
  manageLoyalty,
  refundReturnPolicy,
  loyaltyWidget
];

const loyaltyProgramGroup = new Group(
  'Loyalty Program',
  'loyalty-program',
  routes,
  {
    superRoot: false,
    description:
      'Create happy members and repeat business with this powerful marketing tool.'
  }
);

export { loyaltyProgramGroup };
export default loyaltyProgramGroup;
